import React, { Component } from 'react'
import PropTypes from 'prop-types'
import SelectInput from 'components/Form/components/SelectInput'

import styles from './BannerSelect.scss'

class BannerSelect extends Component {
  static propTypes = {
    currentSelection: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
    handleChange: PropTypes.func,
  }

  static defaultProps = {
    handleChange: null,
  }

  static contextTypes = {
    router: PropTypes.object,
  }

  render() {
    const { currentSelection, options, handleChange } = this.props
    const onBlur = () => { return true }
    const selectInputProps = {
      handleChange,
      label: '',
      name: 'bannerSelect',
      onBlur,
      options,
      value: currentSelection,
    }

    return (
      <div className={styles.base}>
        <SelectInput {...selectInputProps} />
      </div>
    )
  }
}

export default BannerSelect



// WEBPACK FOOTER //
// ./src/components/BannerSelect/BannerSelect.js